import { css } from '@emotion/css';
import { RootState, useAppSelector } from 'cache/store';
import { colors } from 'constants/theme';
import { StatsGeneralResponse } from 'models/statisticModel';
import gameListInterface from '../stats-general.interface';

interface StastTable {
    gamelst: any;
    rebateList: any;
    newlist: any;
    miniGame: any;
}

interface Props {
    newReg: string | null;
    statsTableData: StastTable;
    statsData: StatsGeneralResponse;
}

function InfoStatsGeneral(props: Props) {
    const { newReg, statsTableData, statsData } = props;
    const { agentType } = useAppSelector((state: RootState) => state.auth);

    const calcWithdraw = () => {
        let wd = statsTableData.newlist.wd;
        if (statsTableData.newlist.adjmoney) {
            wd += statsTableData.newlist.adjmoney;
        }

        if (wd === undefined) {
            return '';
        }
        return new Intl.NumberFormat().format(wd);
    };

    const calcBetWin = (group: 'xosotruyenthong' | 'xosonhanh' | 'dangian' | 'minigame', isWin?: boolean) => {
        if (Object.keys(statsTableData.newlist).length > 0) {
            const gameSelect = gameListInterface.find((game) => game.id === group);
            if (gameSelect) {
                let totalGame = 0;
                gameSelect.gameGroup.forEach((item) => {
                    if (!item.key.includes('total')) {
                        const key = !isWin ? item.key : `${item.key}win`;
                        const value = statsTableData.newlist[key];
                        // Chỉ cộng nếu value là số hợp lệ
                        if (typeof value === 'number' && !isNaN(value)) {
                            totalGame += value;
                        }
                    }
                });
                return new Intl.NumberFormat().format(totalGame);
            }
        } else {
            return '';
        }
    };

    // Tổng cược/trúng lấy thẳng field tổng hợp backend (đã gồm JILI & mọi game 3rd),
    // thay cho việc cộng tay từng provider ở client (cách cũ bỏ sót jili).
    const calcTotalBetWin = (type: 'bet' | 'win') => {
        const { newlist } = statsTableData;
        if (Object.keys(newlist).length > 0) {
            const value = type === 'bet' ? statsData.totalBet : statsData.totalWin;
            return new Intl.NumberFormat().format(Number(value || 0));
        } else {
            return '';
        }
    };

    const calcTotalAllGame = () => {
        const { newlist } = statsTableData;
        let classString = 'text-success';
        if (Object.keys(newlist).length > 0) {
            // Lợi nhuận ròng = Trúng + Chiết khấu + Khuyến mãi - Cược
            const totalAllGame =
                Number(statsData.totalWin || 0) +
                Number(newlist.fd || 0) +
                Number(newlist.bonus || 0) -
                Number(statsData.totalBet || 0);

            if (totalAllGame < 0) classString = 'text-error';
            return (
                <span className={classString} style={{ fontWeight: '500' }}>
                    {new Intl.NumberFormat().format(totalAllGame)}
                </span>
            );
        } else {
            return '';
        }
    };
    return (
        <div className={styles.wrap}>
            {agentType !== 2 && (
                <>
                    <div className={styles.group100}>
                        <div className={styles.group50}>
                            <p>Tổng số thành viên</p>
                            <p>{newReg || 0}</p>
                        </div>
                        <div className={styles.group50}></div>
                    </div>
                    <div className={styles.group100}>
                        <div className={styles.group50}>
                            <p>Nạp tiền</p>
                            <p>{statsTableData.newlist.dp === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.dp)}</p>
                        </div>
                        <div className={styles.group50}>
                            <p>Rút tiền</p>
                            <p>{calcWithdraw() || 0}</p>
                        </div>
                    </div>
                </>
            )}
            {agentType === 1 && (
                <>
                    <div className={styles.group100}>
                        <div className={styles.group50}>
                            <p>Nạp tiền cấp dưới</p>
                            <p>{statsTableData.newlist.dpxj === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.dpxj)}</p>
                        </div>
                        <div className={styles.group50}>
                            <p>Rút tiền cấp dưới</p>
                            <p>{statsTableData.newlist.wdchild === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.wdchild)}</p>
                        </div>
                    </div>
                </>
            )}
            {agentType === 2 && (
                <>
                    <div className={styles.group100}>
                        <div className={styles.group50}>
                            <p>Nạp tiền từ cấp trên</p>
                            <p>{statsTableData.newlist.dpxj === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.dpxj)}</p>
                        </div>
                        <div className={styles.group50}>
                            <p>Rút tiền từ cấp trên</p>
                            <p>{statsTableData.newlist.wdchild === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.wdchild)}</p>
                        </div>
                    </div>
                </>
            )}
            <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Cược xổ số truyền thống</p>
                    <p>{calcBetWin('xosotruyenthong') || 0}</p>
                </div>
                <div className={styles.group50}>
                    <p>Trúng xổ số truyền thống</p>
                    <p>{calcBetWin('xosotruyenthong', true) || 0}</p>
                </div>
            </div>
            <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Cược xổ số nhanh</p>
                    <p>{calcBetWin('xosonhanh') || 0}</p>
                </div>
                <div className={styles.group50}>
                    <p>Trúng xổ số nhanh</p>
                    <p>{calcBetWin('xosonhanh', true) || 0}</p>
                </div>
            </div>
            <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Cược game Dân gian</p>
                    <p>{calcBetWin('dangian') || 0}</p>
                </div>
                <div className={styles.group50}>
                    <p>Trúng game Dân gian</p>
                    <p>{calcBetWin('dangian', true) || 0}</p>
                </div>
            </div>
            {/* <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Cược Mini game</p>
                    <p>{calcBetWin('minigame')}</p>
                </div>
                <div className={styles.group50}>
                    <p>Trúng Mini game</p>
                    <p>{calcBetWin('minigame', true)}</p>
                </div>
            </div> */}
            <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Tổng đặt cược</p>
                    <p>{calcTotalBetWin('bet') || 0}</p>
                </div>
                <div className={styles.group50}>
                    <p>Tổng trúng</p>
                    <p>{calcTotalBetWin('win') || 0}</p>
                </div>
            </div>
            <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Chiết khấu</p>
                    <p>{statsTableData.newlist.fd === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.fd)}</p>
                </div>
                <div className={styles.group50}>
                    <p>Khuyến mãi</p>
                    <p>
                        {statsTableData.newlist.bonus === undefined ? '0' : new Intl.NumberFormat().format(statsTableData.newlist.bonus)}
                    </p>
                </div>
            </div>
            <div className={styles.group100}>
                <div className={styles.group50}>
                    <p>Lợi nhuận ròng</p>
                    <p>{calcTotalAllGame() || 0}</p>
                </div>
                <div className={styles.group50}>
                    <span className="text-error" style={{ fontSize: '14px' }}>
                        Lợi nhuận ròng = Trúng + Chiết khấu + Khuyến mãi - Cược.
                    </span>
                </div>
            </div>
        </div>
    );
}

const styles = {
    wrap: css`
        box-shadow: 0px 1px 4px #a0a0a0;
        border-top: none;
        border-radius: 10px;
        padding: 15px;
        margin-top: 10px;
    `,
    group50: css`
        display: flex;
        flex: 0 0 50%;
        padding: 8px;
        color: var(--agent-color);
        background: ${colors.white};
        /* &:hover {
            background: #201b4c
        } */
        &:first-child {
            border-right: 1px solid #c0c0c0;
        }
        p {
            flex: 0 0 50%;
            &:last-child {
                text-align: right;
            }
        }
    `,
    group100: css`
        display: flex;
        flex: 0 0 100%;
        border-bottom: 1px solid ${colors.blue};
    `,
};

export default InfoStatsGeneral;
